import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from '../models/modalConfig';
import { UploadReqUpdateLocationModalComponent } from 'src/app/pages/mission-control-page/upload-req-page/upload-req-update-location-modal/upload-req-update-location-modal.component';

@Injectable({
  providedIn: 'root'
})
export class UploadReqUpdateLocationModalService {

  updateLocationModal!: BsModalRef;

  constructor(private bsModalService: BsModalService) { }

  show(jobId: any, location: any, saveCallback: (locationObject: any) => void, clearCallback: () => void): void {
    const config = new ModalConfig();
    config.class = 'modal-lg';
    config.initialState = { jobId, location, saveCallback, clearCallback };
    this.updateLocationModal = this.bsModalService.show(UploadReqUpdateLocationModalComponent, config);
  }
}
